import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  allowBlockApp,
  allowBlockCategory,
  appActivityList,
  setAppActivityData,
} from "../../../AxiosRtk/AppActivity";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import Select from "react-select";
import { CustomTooltip } from "../../Dashboard/DashboardGraph/ScreenTime";
import { Link } from "react-router-dom";
import ScreenshotsFilter from "../../modals/ScreenshotsFilter";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import useLangTranslation from "../../../../customHooks/languageProvider";
import useDurationOption from "../../../../customHooks/durationOption";
import { handleStartDateCommon } from "../../../../../utils/helper";
import DateFilter from "../../../../shared/DateFilter/DateFilter";

const ActivityScreen = ({
  selectedDeviceId,
  startDate,
  endDate,
  setEndDate,
  setStartDate,
  filterData,
  setFilterData,
}) => {
  const dispatch = useDispatch();
  const { getLangTranslation } = useLangTranslation();
  const { durationOptionsFunction } = useDurationOption();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const { appActivityData } = useSelector(({ appActivity }) => appActivity);
  const [graphType, setGraphType] = useState("APP");

  const data = appActivityData?.mostUsedApps;
  const appBasedGraphData = appActivityData?.appBasedData;
  const appCategoryBasedData = appActivityData?.appCategoryBasedData;
  let dataGraph = [];

  const { selectedKidId } = useSelector(({ dashboard }) => dashboard);
  const [time, setTime] = useState(true);
  const [graphData, setGraphData] = useState([]);
  const [bars, setBars] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    function timeToMinutes(sec) {
      return (sec / 60)?.toFixed(2);
    }

    const barMap = new Map();
    const graphBarMap = new Map();
    dataGraph = graphType === "APP" ? appBasedGraphData : appCategoryBasedData;
    dataGraph?.forEach((item) => {
      if (graphType === "APP") {
        if (item?.appName && item?.color && !barMap?.has(item?.appName)) {
          barMap?.set(item?.appName, item?.color);
        }
      } else {
        if (item?.category && item?.color && !barMap?.has(item?.category)) {
          barMap?.set(item?.category, item?.color);
        }
      }

      if (graphBarMap.has(Number(item?.hour) + 1)) {
        const obj = { ...graphBarMap.get(Number(item?.hour) + 1) };
        if (
          obj[item[graphType === "APP" ? "appName" : "category"]?.split(" ")[0]]
        ) {
          obj[
            item[graphType === "APP" ? "appName" : "category"]?.split(" ")[0]
          ] =
            +obj[
            item[graphType === "APP" ? "appName" : "category"]?.split(" ")[0]
            ] + +item?.duration;
        } else {
          obj[
            item[graphType === "APP" ? "appName" : "category"]?.split(" ")[0]
          ] = item?.duration;
        }

        graphBarMap.set(Number(item?.hour) + 1, obj);
      } else {
        const tempObj = {
          name: Number(item?.hour) + 1,
          [item[graphType === "APP" ? "appName" : "category"]?.split(" ")[0]]:
            timeToMinutes(item?.duration),
        };
        graphBarMap.set(Number(item?.hour) + 1, { ...tempObj });
      }
    });

    const dataBarMap = Array.from(barMap, ([key, value]) => ({
      dataKey: key,
      fill: value,
    }));
    setBars(dataBarMap);
    const graphBarMapData = Array.from(graphBarMap, ([key, value]) => value);
    setGraphData(graphBarMapData);
  }, [appActivityData, graphType]);

  const calculatePercentage = (duration, totalTimeInSeconds) => {
    return (duration / totalTimeInSeconds) * 100;
  };

  const formatDuration = (durationInSeconds) => {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;
    return `${hours} h ${minutes} m ${seconds} s`;
  };

  //  Total time calculation for All app used
  const totalTimeInSeconds = data?.reduce(
    (total, app) => total + app.duration,
    0
  );

  function handleAllowBlockApp(
    appId,
    appName,
    selectedDeviceId,
    selectedKidId,
    endDate,
    packageName,
    status
  ) {
    const payload = {
      appId: appId,
      appName: appName,
      case: 8,
      is_load_default_settings: 0,
      kidDeviceId: selectedDeviceId,
      kidId: selectedKidId,
      packageName: packageName,
      status: status,
    };


    allowBlockApp(payload)
      .then((res) => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: res?.data?.message,
            message: res?.data?.message,
          })
        );
      })
      .then(() => {
        const payload = {
          deviceId: selectedDeviceId,
          startDate,
          endDate,
          pageNo: 1,
          itemsPerPage: 200000,
        };
        appActivityList(payload)
          .then((res) => {
            dispatch(setAppActivityData(res?.data?.result));
          })
          .catch((err) => {
            console.error(
              "App activity catch error: ",
              err?.response?.fdata?.message
            );
          });
      })
      .catch((err) => {
        console.log(
          "allow block app catch error  ==>>",
          err?.response?.data?.message
        );
      });
  }

  function handleAllowBlockCategory(
    selectedKidId,
    selectedDeviceId,
    appCategoryId,
    appCategoryStatus
  ) {
    const payload = {
      userId: selectedKidId,
      is_load_default_settings: 0,
      deviceId: selectedDeviceId,
      categoryType: "APP",
      categoryStatus: appCategoryStatus,
      categoryIds: [appCategoryId],
    };

    allowBlockCategory(payload)
      .then((res) => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: res?.data?.message,
            message: res?.data?.message,
          })
        );
      })
      .then(() => {
        const payload = {
          deviceId: selectedDeviceId,
          startDate,
          endDate,
          pageNo: 1,
          itemsPerPage: 200000,
        };
        appActivityList(payload)
          .then((res) => {
            dispatch(setAppActivityData(res?.data?.result));
          })
          .catch((err) => {
            console.error(
              "App activity catch error: ",
              err?.response?.fdata?.message
            );
          });
      })
      .catch((err) => {
        console.log(
          "allow block app catch error  ==>>",
          err?.response?.data?.message
        );
      });
  }
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  return (
    <>
      <div className="card border-0 mb-6">
        <div className="card-body">
          <div className="d-flex align-items-center flex-wrap gap-3 mb-6">
            <h6 className="mb-0">
              {getLangTranslation("PERCENTAGE_FILTER", "Percentage (%)")}
            </h6>
            <span
              className={`form-check form-switch align-self-center mb-0 ${lang?.isRTL === 1 ? "ms-auto" : "me-auto"
                }`}
            >
              <input
                className="form-check-input"
                id="percentageTime"
                type="checkbox"
                role="switch"
                checked={time}
                onChange={() => setTime(!time)}
              />
              <label
                className="form-check-label text-blue-800 fw-semibold"
                htmlFor="percentageTime"
              >
                {time ? "Time" : "Percentage"}
              </label>
            </span>

            <DateFilter
              startDate={startDate}
              endDate={endDate}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              selectedDuration={selectedDuration}
            />
            <Select
              className="custom-select col-lg-2"
              classNamePrefix="custom-select"
              placeholder="Select"
              onChange={(val) => {
                handleStartDateCommon(
                  val,
                  setStartDate,
                  setSelectedDuration,
                  setEndDate
                );
              }}
              options={durationOptions}
              value={
                durationOptions?.find(
                  (item) => item?.value === selectedDuration
                ) || ""
              }
            />
            <span
              className="icon-wrap pt-cursor bg-gray-300"
              onClick={openModal}
            >
              <i className="icon-filter" />
            </span>
          </div>
          <div className="grid gap-3">
            {data?.map((data, index) => {
              const valueToShow = time
                ? formatDuration(data.duration)
                : `${Math.round(
                  calculatePercentage(data.duration, totalTimeInSeconds)
                )}%`;

              const percentage = calculatePercentage(
                data.duration,
                totalTimeInSeconds
              );
              return (
                <div
                  key={index}
                  className={`g-col-md-6 g-col-12 border rounded-3 p-3 ${index === hoveredIndex ? "bg-blue-50" : ""
                    }`}
                >
                  <Link to={`/activity-details/${data.appId}`}>
                    <div
                      className="d-flex align-items-center mb-3 pt-cursor gap-3"
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <span className="icon-wrap">
                        <img src={data.icon} width="22px" />
                      </span>
                      <div className="flex-grow-1">
                        <p className="d-flex text-small gap-3 mb-3 ">
                          <span className="text-dark">{data.appName}</span>{" "}
                          <span className="me-auto text-gray">
                            {data.category}
                          </span>
                          <span className="text-gray">{valueToShow}</span>{" "}
                        </p>
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Basic example"
                          aria-valuenow={percentage}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          <div
                            className="progress-bar"
                            style={{ width: `${percentage}%` }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </Link>
                  <div className="grid gap-3">
                    <button
                      className="btn btn-sm btn-outline-default g-col-6 d-inline-flex align-items-center justify-content-center gap-1"
                      onClick={() =>
                        handleAllowBlockApp(
                          data.appId,
                          data.appName,
                          selectedDeviceId,
                          selectedKidId,
                          endDate,
                          data.packageName,
                          data.appStatus === 0 ? 1 : 0
                        )
                      }
                    >
                      <i
                        className={`icon-${data?.appStatus === 0 ? "lock" : "unlock"
                          } fs-5`}
                      />
                      {data?.appStatus === 0
                        ? getLangTranslation("ALLOW_THE_APP", "Allow the app")
                        : getLangTranslation("BLOCK_THE_APP", "Block the app")}
                    </button>
                    <button
                      className="btn btn-sm btn-outline-default g-col-6 d-inline-flex align-items-center justify-content-center gap-1"
                      onClick={() =>
                        handleAllowBlockCategory(
                          selectedKidId,
                          selectedDeviceId,
                          data.appCategoryId,
                          data.appCategoryStatus === 0 ? 1 : 0
                        )
                      }
                    >
                      <i className="icon-check-round fs-5" />
                      {data?.appCategoryStatus === 0
                        ? getLangTranslation(
                          "ALLOW_THE_CATEGORY",
                          "Allow the category"
                        )
                        : getLangTranslation(
                          "BLOCK_THE_CATEGORY",
                          "Block the category"
                        )}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          {data?.length === 0 && (
            <div className="text-center my-3">
              {getLangTranslation(
                "PARENT_NOTIFICATION_EMPTY_DATA",
                "No Data Found"
              )}
            </div>
          )}
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center flex-wrap gap-3 mb-6">
            <h6 className="mb-0">
              {getLangTranslation("BY_CATEGORY", "By category")}
            </h6>
            <span
              className={`form-check form-switch align-self-center mb-0 ${lang?.isRTL === 1 ? "ms-auto" : "me-auto"
                }`}
            >
              <input
                className="form-check-input"
                id="deviceTime"
                type="checkbox"
                role="switch"
                checked={graphType === "APP"}
                onChange={(e) =>
                  setGraphType(e.target.checked === true ? "APP" : "CATEGORY")
                }
              />
              <h6 className="mb-0">
                {getLangTranslation(
                  "SCREENSHOT_HITORY_FILTER_BY_APP",
                  "By app"
                )}
              </h6>
            </span>
          </div>
          <div className="graph">
            <ResponsiveContainer width="100%" height={520}>
              <BarChart width={1000} height={520} data={graphData}>
                <CartesianGrid strokeDasharray="3 3" />
                <YAxis label={{ value: getLangTranslation("PARENT_DASHBOARD_MINUTES", "minutes"), angle: -90, position: "insideLeft" }} />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                {bars?.map((item) => (
                  <Bar
                    key={item.fill}
                    dataKey={item.dataKey}
                    stackId="a"
                    fill={item.fill}
                  />
                ))}
                <XAxis dataKey="name" label={{ value: getLangTranslation("PARENT_DASHBOARD_HOURS", "Hours"), position: "insideBottom", offset: -5 }} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      <ScreenshotsFilter
        showModal={showModal}
        closeModal={closeModal}
        filterData={filterData}
        setFilterData={setFilterData}
      />
    </>
  );
};

export default ActivityScreen;
